export default __webpack_public_path__ + "static/hover_10-1825273734c7b8f831c3e00417804aa1.png";